import React, {useEffect, useMemo, useState} from 'react';
import {Responsive, WidthProvider} from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import ChartViewer from "../pages/DataGridImplementations/DataGridImplementationDetailsView/ChartViewer";
import CloseIcon from "@mui/icons-material/Close";
import {Box, Card, CardHeader, IconButton, Typography, useMediaQuery} from "@mui/material";
import DialogConfirm from "./DialogConfirm";
import localStrings from "../localStrings";
import enqueueSnackbarWithSound from "../utils/SnackBarWithSound";
import {toast} from "react-hot-toast";
import cloneDeep from "clone-deep";
import debounce from 'lodash/debounce';
import SummaryGridView from "../pages/Accounting/SummaryGridView";
import {executeMutationUtil, executeQueryUtil} from "../utils/gqlUtil";
import {getDataGridImplementationsQuery} from "../gql/dataGridImplementationGql";
import {decode as base64_decode, encode as base64_encode} from "base-64";
import {useTheme} from "@mui/material/styles";

const ResponsiveGridLayout = WidthProvider(Responsive);

function GridLayoutForGraph({chartBoardsItems,
                                removeChartBoardItemCallBack, reorganizeActive, updateItemCallBack}) {

    const [confirmRemove, setConfirmRemove] = useState(false);
    const [removedItem, setRemovedItem] = useState(null);
    const [dataGridImplementations, setDataGridImplementations] = useState(null);
    const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
    const theme = useTheme();

    function buildDataGridLayout(item) {
        return {
            x: item.xGrid || 0,
            y: item.yGrid || 0,
            w: !lgUp ? 12 : item.wGrid || 12,
            h: item.hGrid || 4,
            i: item.id,
        };
    }

    useEffect(() => {
        const loadDataGridImplementations = async () => {
            const resDataGrids = await executeQueryUtil(getDataGridImplementationsQuery());
            setDataGridImplementations(resDataGrids.data.getDataGridImplementations);
        }
        loadDataGridImplementations();
    }, []);




    const handleLayoutChange = async (layout) => {
        console.log("layout", JSON.stringify(layout));
        if (!reorganizeActive) return;

        let changed = false;
        for (let i = 0; i < layout.length; i++) {
            const layoutElement = layout[i];

            const item = chartBoardsItems.find(item => item.id === layoutElement.i);
            const itemCloned = cloneDeep(item);
            if (itemCloned.xGrid !== layoutElement.x ||
                itemCloned.yGrid !== layoutElement.y ||
                itemCloned.wGrid !== layoutElement.w ||
                itemCloned.hGrid !== layoutElement.h) {

                itemCloned.xGrid = layoutElement.x;
                itemCloned.yGrid = layoutElement.y;
                itemCloned.wGrid = layoutElement.w;
                itemCloned.hGrid = layoutElement.h;

                await updateItemCallBack(itemCloned);
                changed = true;
            }
        }

        if (changed) {
            enqueueSnackbarWithSound(toast, null, null,
                localStrings.notif.chartReorganizationDone);
        }
    };

    const debouncedLayoutChange = useMemo(() => debounce(handleLayoutChange, 700),
        [chartBoardsItems, reorganizeActive]);


// Example usage:
//     console.log(getRandomColor()); // e.g., "#3E2F1B"

    function getDataGridImpl(item) {
        return dataGridImplementations.find(dg => dg.id === item.dataGridImplementationId);
    }

    function getPivotModel(item) {
        let dataGridImpl = getDataGridImpl(item);
        if (dataGridImpl && dataGridImpl.pivotModelContent) {
            try {
                return JSON.parse(base64_decode(dataGridImpl.pivotModelContent));
            } catch (e) {
                console.error("Error parsing pivot model content:", e);
                // return {};
            }
        }
    }

    function getPivotActive(item) {
        let dataGridImpl = getDataGridImpl(item);
        return dataGridImpl ? dataGridImpl.usePivot : false;
    }

    return (
        <div>

            <DialogConfirm
                dialogOpen={confirmRemove}
                handleClose={() => setConfirmRemove(false)}
                handleConfirm={() => {
                    setConfirmRemove(false);
                    removeChartBoardItemCallBack(removedItem)
                }}
                title={localStrings.confirmMessage.deleteChartFromDashboard}
            >

            </DialogConfirm>

            <ResponsiveGridLayout
                className="layout"
                // layouts={layouts}
                sx={{
                    margin: '0px',
                }}
                onLayoutChange={debouncedLayoutChange}
                isDraggable={reorganizeActive}
                isResizable={reorganizeActive}
                breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
                cols={{ lg: 12, md: 12, sm: 12, xs: 12, xxs: 12 }}
            >
                {(chartBoardsItems || []).map((item, key) => {

                    return (
                        <div key={item.id}
                             style={{
                                 border: '1px solid #ccc',
                                 borderRadius: '10px',
                             }}
                             data-grid={buildDataGridLayout(item)}
                        >
                            <tooltip title={localStrings.removeGraphFromDashBoard}>
                                <IconButton
                                    size="small"
                                    onClick={() => {
                                        setRemovedItem(item);
                                        setConfirmRemove(true);
                                        // Appelle une fonction de suppression ici
                                        // console.log("Remove item", item);
                                    }}
                                    sx={{
                                        position: 'absolute',
                                        top: 8,
                                        right: 4,
                                        zIndex: 1,
                                        backgroundColor: 'white',
                                        '&:hover': {
                                            backgroundColor: '#f0f0f0',
                                        },
                                    }}
                                >
                                    <CloseIcon fontSize="small"/>
                                </IconButton>
                            </tooltip>

                            { item.chartImplementationId &&
                                <ChartViewer chartImplementationId={item.chartImplementationId}/>
                            }

                            { dataGridImplementations && item.dataGridImplementationId &&
                                // <>
                                <Card
                                    sx={{
                                        borderRadius: '5px',
                                    }}

                                >
                                    <CardHeader
                                        titleTypographyProps={{
                                            variant: 'h6',
                                            sx: {
                                                color: theme.palette.primary.contrastText,
                                                fontWeight: 600,
                                                marginTop: '4px',
                                                marginBottom: '4px',
                                            },
                                        }}
                                        sx={{
                                            backgroundColor: theme.palette.primary.main,
                                            py: 1,
                                            px: 2,
                                            borderRadius: '5px',
                                        }}
                                        title={getDataGridImpl(item)?.title || ""}
                                    />




                                    {/*{getDataGridImpl(item) &&*/}
                                    {/*    <Box sx={{*/}
                                    {/*        width: '100%',*/}
                                    {/*    }}>*/}
                                    {/*        <Typography variant="h6" sx={{margin: 1}}>*/}
                                    {/*            {getDataGridImpl(item)?.title}*/}
                                    {/*        </Typography>*/}
                                    {/*    </Box>*/}
                                    {/*}*/}
                                    <SummaryGridView
                                        displayToolBar={false}
                                        pivotModel={getPivotModel(item)}
                                        pivotActive={getPivotActive(item)}
                                    />
                                </Card>
                            }
                        </div>
                    )
                })}

            </ResponsiveGridLayout>
        </div>
    )
}

export default GridLayoutForGraph